import styles from '../components/MailRibbon.scss';
import { CommandBarButton } from '@fluentui/react/lib/Button';
import type { IKeytipProps } from '@fluentui/react/lib/Keytip';
import { getIsViewModeSelected } from 'owa-command-ribbon-store';
import { isFeatureEnabled } from 'owa-feature-flags';
import Open from 'owa-fluent-icons-svg/lib/icons/OpenRegular';
import loc from 'owa-localize';
import PopoutStrings from 'owa-locstrings/lib/strings/popoutsopeninnewwindow.locstring.json';
import { popoutCompose } from 'owa-mail-compose-command';
import { getMainWindowComposeViewState } from 'owa-mail-compose-actions/lib/selectors/getMainWindowComposeViewState';
import { CommandingViewMode } from 'owa-outlook-service-option-store/lib/store/schema/options/CommandingOptions';
import { UpNextV2 } from 'owa-upnext-v2';
import { isDeepLink } from 'owa-url';
import * as React from 'react';
import getFullComposeShowingInTabContentArea from 'owa-mail-compose-actions/lib/selectors/getFullComposeShowingInTabContentArea';
import { MonarchWin32Toggle, isToggleEnabled } from 'native-newoutlook-toggle';

const upNextButtonStyles = {
    root: styles.upNextButtonRoot,
    flexContainer: {
        height: 'auto',
        lineHeight: '15px',
        paddingRight: '20px',
    },
};

const popoutDraftButtonStylesSLR = {
    root: styles.popoutDraftButtonRoot,
    icon: { display: 'flex' },
};

const popoutDraftButtonStylesMLR = {
    root: styles.popoutDraftButtonRoot,
    icon: { display: 'flex', fontSize: '32px', height: '32px' },
};

export function getExtraBottomRibbonControls(): JSX.Element[] {
    let bottomRibbonControls: JSX.Element[] = [];

    const isFullCompose = getFullComposeShowingInTabContentArea() !== null;
    if (isFullCompose) {
        if (!isDeepLink()) {
            // Popout button for draft
            const key: string = 'P';
            const keytipProps: IKeytipProps | undefined = isFeatureEnabled('mon-ribbon-keytips')
                ? {
                      content: key,
                      keySequences: [key.toLocaleLowerCase()],
                      onExecute: () => {
                          popoutDraft();
                      },
                  }
                : undefined;

            bottomRibbonControls.push(
                <div
                    key="PopoutDraftFullCompose_Ribbon"
                    style={{ alignSelf: 'center', display: 'flex', height: '100%' }}>
                    <CommandBarButton
                        aria-label={loc(PopoutStrings.popoutsOpenInNewWindow)}
                        iconProps={{ iconName: Open }}
                        onClick={popoutDraft}
                        styles={
                            getIsViewModeSelected(CommandingViewMode.MultiLineRibbon)
                                ? popoutDraftButtonStylesMLR
                                : popoutDraftButtonStylesSLR
                        }
                        title={loc(PopoutStrings.popoutsOpenInNewWindow)}
                        keytipProps={keytipProps}
                    />
                </div>
            );
        }
    } else if (getIsViewModeSelected(CommandingViewMode.CommandBar)) {
        // "Up next" calendar peek
        bottomRibbonControls.push(
            <div
                key="UpNextV2_ExtraBottomRibbonControls"
                style={{ alignItems: 'center', display: 'flex' }}>
                <UpNextV2 containerStyle={upNextButtonStyles} />
            </div>
        );

        if (isToggleEnabled()) {
            // Monarch - Win32 toggle
            bottomRibbonControls.push(
                <div style={{ display: 'flex', alignItems: 'center' }}>
                    <MonarchWin32Toggle />
                </div>
            );
        }
    }

    return bottomRibbonControls;
}

function popoutDraft() {
    popoutCompose(getMainWindowComposeViewState()!);
}
